import { cookiePrivacyPolicyPopupStyles } from "@insite/content-library/Components/CookiePrivacyPolicyPopup";
import getColor from "@insite/mobius/utilities/getColor";
import { colorStrings } from "@waytek/Utilities/variables";
import { css } from "styled-components";

cookiePrivacyPolicyPopupStyles.container = {
    ...cookiePrivacyPolicyPopupStyles.container,
    css: css`
        padding: 15px 20px;
        margin: 0 auto;
    `,
};

cookiePrivacyPolicyPopupStyles.drawer = {
    ...cookiePrivacyPolicyPopupStyles.drawer,
    cssOverrides: {
        ...cookiePrivacyPolicyPopupStyles.drawer?.cssOverrides,
        scrim: css`
            ${cookiePrivacyPolicyPopupStyles.drawer?.cssOverrides?.scrim}
            height: auto;
            max-height: 50%;
            overflow-y: auto;
            box-shadow: 0 3px 5px -1px rgb(0, 0, 0, 0.2),
                0 6px 10px 0 rgb(0, 0, 0, 0.14),
                0 1px 18px 0 rgb(0, 0, 0, 0.12);
        `,
        drawerBody: css`
            background: ${getColor(colorStrings.commonGlobalFadedTaupe)};
            height: 100%;
            padding: 15px 0;
            position: relative;
        `,
        drawerContent: css`
            margin: 0 auto;
            width: 100%;
        `,
    },
};

cookiePrivacyPolicyPopupStyles.messageGridItem = {
    ...cookiePrivacyPolicyPopupStyles.messageGridItem,
    width: [12, 12, 7, 8, 9],
};

cookiePrivacyPolicyPopupStyles.acceptGridItem = {
    ...cookiePrivacyPolicyPopupStyles.acceptGridItem,
    width: [8, 9, 3, 3, 2],
};
